module.exports = "https://lts-static.prod-my.games/promo/lp1/img/logo.621eccd9.webp";